var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.636,
    height: 20.49,
    viewBox: "0 0 14.636 20.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.074,4H22.561A2.564,2.564,0,0,0,20,6.561v7.318h1.515a1.464,1.464,0,1,1,0,.732H20V24.49H34.636V6.561A2.564,2.564,0,0,0,32.074,4ZM24.391,22.66a.366.366,0,0,1-.366.366h-2.2a.366.366,0,0,1-.366-.366v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a.366.366,0,0,1-.366.366h-2.2A.366.366,0,0,1,21.464,19v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm.732-4.757a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,25.122,14.245Zm4.025,8.415a.366.366,0,0,1-.366.366h-2.2a.366.366,0,0,1-.366-.366v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a.366.366,0,0,1-.366.366h-2.2A.366.366,0,0,1,26.22,19v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,29.147,15.343Zm4.025,7.318a.366.366,0,0,1-.366.366H30.977a.366.366,0,0,1-.366-.366V16.806a.366.366,0,0,1,.366-.366h1.829a.366.366,0,0,1,.366.366Zm-1.1-7.318a1.1,1.1,0,1,1,1.1-1.1,1.1,1.1,0,0,1-1.1,1.1Zm1.1-3.659a.366.366,0,0,1-.366.366H21.829a.366.366,0,0,1-.366-.366V5.829a.366.366,0,0,1,.366-.366H32.806a.366.366,0,0,1,.366.366Z",
    transform: "translate(-20 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.9c368fc47f25adef3c98938544cb0a48.svg";
export { ForwardRef as ReactComponent };